import type React from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"

import { Page404 } from "@/components/nav/page404"
import { SigmaReport } from "@/components/sigma-report"
import {
  isEnergyAndWaterUseWorkbookId,
  useSigmaWorkbook,
} from "@/services/sigma"

import ReportLayout from "../../components/reportLayout/reportLayout"
import { reportCard, reportCards } from "../../models/report"
import { useHasWorkbookAccess } from "../../services/use-has-workbook-access/use-has-workbook-access"

export const SigmaReportRoute: React.FC = () => {
  const { t } = useTranslation()
  const { workbookId } = useParams<{ workbookId: string }>()
  const { sigmaWorkbookData, sigmaWorkbookIsLoading } =
    useSigmaWorkbook(workbookId)
  const { hasWorkbookAccess, isWorkbookAccessLoading } =
    useHasWorkbookAccess(workbookId)

  const matchedReportCard = isEnergyAndWaterUseWorkbookId(workbookId)
    ? reportCard.EnergyAndWaterUse
    : reportCards.find((card) => Boolean(card.id) && card.id === workbookId)
  const reportTitleTranslationKey = matchedReportCard?.title
  const reportTitle = reportTitleTranslationKey
    ? t(reportTitleTranslationKey, { ns: "reports" })
    : (sigmaWorkbookData?.name ?? "")

  if (sigmaWorkbookIsLoading || isWorkbookAccessLoading) {
    return null
  }

  if (sigmaWorkbookData === null || !hasWorkbookAccess) {
    return <Page404 />
  }

  return (
    <ReportLayout fullHeight heading={reportTitle}>
      <SigmaReport reportTitle={reportTitle} workbookId={workbookId} />
    </ReportLayout>
  )
}
